import { RefreshCw } from "lucide-react";
import { BaseAppointmentAction, AppointmentActionCategory, UserRole, AppointmentActionContext, AppointmentActionPayload, AppointmentActionResult } from "../core/base-action";
import { SERVICE_CHANGEABLE_STATUSES } from "@/lib/appointment-change";
import { AppointmentApprovalService } from "@/services/appointment-approval.service";

export class ServiceChangeAction extends BaseAppointmentAction {
    readonly config = {
        id: "change_service",
        label: "Change Service",
        description: "Request service change approval",
        icon: RefreshCw,
        category: AppointmentActionCategory.REQUEST,
        permissions: {
            requiredRole: [UserRole.PMC, UserRole.VENDOR],
            requiredStatuses: [...SERVICE_CHANGEABLE_STATUSES]
        },
        requiresDialog: true,
        variant: "default" as const
    };

    validatePayload(payload?: AppointmentActionPayload): string | null {
        if (!payload?.newServiceId) {
            return "New service selection is required";
        }
        if (!payload?.newServiceName) {
            return "New service name is required";
        }
        if (!payload?.parentCategory) {
            return "Service category is required";
        }
        return null;
    }

    getDialogComponent(): string {
        return "ServiceChangeDialog";
    }

    async execute(
        context: AppointmentActionContext,
        payload?: AppointmentActionPayload
    ): Promise<AppointmentActionResult> {
        try {
            const { newServiceId, newServiceName, parentCategory, roomId } = payload || {};
            
            if (!newServiceId || !newServiceName || !parentCategory) {
                throw new Error("Service change details are required");
            }

            if (!roomId) {
                throw new Error("Room ID is required for approval requests");
            }

            await AppointmentApprovalService.sendApprovalRequest(roomId, { type: "serviceChange", service: newServiceId });

            return {
                success: true,
                message: `Service change request sent for approval`
            };
        } catch (error: any) {
            return {
                success: false,
                message: error.message || "Failed to send service change request"
            };
        }
    }
}